import { Eye } from "lucide-react";
import { useSession } from "next-auth/react";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { FaRegFileAlt } from "react-icons/fa";
import io from "socket.io-client";
import { default as Loader } from "../../components/Loader";
import Scheduler from "../../components/scheduler";
import { POLYGON_IO_URL } from "../../config";
import ViewModal from "./components/StrategyViewModal";
import {
  DP22,
  FX_MULTIPLIER,
  FX_MULTIPLIER_XAGUSD,
  calculateDifference,
  Pagination,
  fetchColor,
  formatDate,
  formatEpochDate,
  generateTokenForSocket,
  getDPFor,
  getIsCrypto,
  getIsFxStrategy,
  getOrderType,
  isMetals_SILVER,
  minFixedDecimal,
  stripPioSymbolFromSymbol,
  toNumberAndSign,
  toNumberOrNull,
  DP44,
  getMultiplier,
  capitalizeFirstLetter,
} from "../../helpers/helperFunctions";
//@ts-ignore
import TotalWinLossCalculator from "@/components/TotalWinLossCalculator";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import {
  PIOAggregates,
  PIOAggregatesPerSecond,
  PIOCryptoAggregatesPerSecond,
  PIOFairMarketValue,
  PIO_CONST,
  SIOSubscription,
} from "@/config/polygon-constants";
import { useDarkTheme } from "@/contexts/DarkTheme";
import { useSubscription } from "@/contexts/SubscriptionContext";
import { AccentColor } from "@/helpers/types";
import { cn, formatCurrency } from "@/lib/utils";
import { difference, uniq } from "lodash";
//@ts-ignore
import UndeployModal from "@/components/common/UndeployModal";
import DeployedScannersTable from "@/components/deploy/DeployedScannersTable";
import { Badge } from "@/components/ui/badge";
import dynamic from "next/dynamic";
import { BiRadar, BiSolidHelpCircle } from "react-icons/bi";
import { IoExtensionPuzzleSharp } from "react-icons/io5";
import { MdDone, MdOutlineKeyboardArrowRight } from "react-icons/md";
import {
  Line,
  LineChart,
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import { useSearchParams } from "next/navigation";
import {
  useGetAllLiveDeployment,
  useGetAllLiveDeploymentOrderStatus,
  useGetExpiredPLs,
  useGetExpiredStrategies,
  useGetLiveDeploymentStats,
  useGetLiveStrategiesVolume,
  useGetLogos,
  useGetMonitorDeploymentStats,
  useGetPL,
  usePostUndeployLiveStrategy,
} from "@/api/strategyApi";
import { useUserContext } from "@/contexts/userContext";
import { FiCopy } from "react-icons/fi";
import SlipageChart from "@/components/common/charts/SlipageChart";
import { useGetSymbolData } from "@/api/symbolApi";
import { CURRENT_BROKER_ID, CURRENT_BROKER_NAME } from "@/config/logos";
import RunningStrategyCard from "@/components/common/RunningStrategyCard";
import { BsFillLightningChargeFill } from "react-icons/bs";
import clsx from "clsx";
const enviornment = "live";

const MonthlyStrategyPerformance = dynamic(
  () => import("./components/MonthlyStrategyPerformance"),
  {
    ssr: false,
  }
);

const SCANNER_TAB = 6;

const Section3 = () => {
  const { data: session } = useSession();
  const { userType } = useSubscription();
  const { user } = useUserContext();
  const router = useRouter();
  const params = useSearchParams();
  const { darkTheme } = useDarkTheme();
  const { t } = useTranslation("trade");
  const { t: ct } = useTranslation("common");
  const polygonSocket = useMemo(() => io(POLYGON_IO_URL), []);
  const pioDataRef = useRef<string[]>([]);
  const [pioData, setPioData] = useState<{
    [key: string]: PIOAggregates | PIOFairMarketValue;
  }>({});
  const [liveTableData, setLiveTableData] = useState<any>([]);
  const [liveTableCount, setLiveTableCount] = useState(0);
  const [liveTableCurrent, setLiveTableCurrent] = useState(1);
  const [loading, setLoading] = useState(false);
  const liveDataLimit = 6;
  const [decisionLive, setDecisionLive] = useState<any>(new Map());
  const [qtyLive, setQtyLive] = useState<any>(new Map());
  const [exchangeRate, setExchangeRate] = useState<any>(new Map());
  const [realizedPnLLive, setRealizedPnLLive] = useState<any>(new Map());
  const [orderPriceListLive, setOrderPriceListLive] = useState<any>(new Map());
  const [currentPriceListLive, setCurrentPriceListLive] = useState<any>(
    new Map()
  );
  const [viewType, setViewType] = useState("");
  const [logos, setLogos] = useState<any>(new Map());
  const [virtualLogos, setVirtualLogos] = useState<any>(new Map());
  const [expiredStrategyModal, setExpiredStrategyModal] = useState(false);
  const [expiredStrategies, setExpiredStrategies] = useState<any>([]);
  const [expiredVirtualStrategiesCount, setExpiredVirtualStrategiesCount] =
    useState(0);
  const [expiredVirtualStrategiesCurrent, setExpiredVirtualStrategiesCurrent] =
    useState(1);
  const [expiredLiveStrategiesCount, setExpiredLiveStrategiesCount] =
    useState(0);
  const [expiredLiveStrategiesCurrent, setExpiredLiveStrategiesCurrent] =
    useState(1);
  const [expiredPLs, setExpiredPLs] = useState<any>(new Map());
  const [volume, setVolume] = useState<any>({});
  const expiredStrategiesLimit = 6;

  const [liveTableDataLoader, setLiveTableDataLoader] = useState<any>(true);

  const [liveOrderPosition, setLiveOrderPosition] = useState<any>();
  const [SCTab, setSCTab] = useState<any>(Number(CURRENT_BROKER_ID));
  const [monthlyData, setMonthlyData] = useState<any>([]);
  const [chartData, setChartData] = useState<any>();
  const [isCopied, setIsCopied] = useState<any>(false); //copy the strategy id
  const [copiedStrategyId, setCopiedStrategyId] = useState<string>("");
  const [latencyData, setLatencyData] = useState<any>(null);
  const lastFetchTime = useRef(Date.now());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>({});
  const [undeployData, setUnDeployData] = useState({
    open: false,
    strategyId: "",
  });
  const expiry = 90 * 24 * 3600;
  const [loadingStates, setLoadingStates] = useState<any>({});
  const live = true;
  const {
    data: liveDeploymentData,
    refetch: refetchLiveDeploymen,
    isLoading: liveDeploymentLoading,
    isSuccess: liveDeploymentSuccess,
  } = useGetAllLiveDeployment(
    user?.user_id,
    CURRENT_BROKER_ID as unknown as string,
    liveTableCurrent
  );

  const {
    data: monitorDeploymentData,
    isLoading: monitorDeploymentLoading,
    isSuccess: monitorDeploymentSuccess,
  } = useGetMonitorDeploymentStats(user?.user_id, CURRENT_BROKER_ID);

  const {
    mutateAsync: getOrderStatus,
    data: orderStatusData,
    isPending: orderStatusPending,
    isSuccess: orderStatusSuccess,
  } = useGetAllLiveDeploymentOrderStatus();
  const {
    mutateAsync: getLiveStrategyVolume,
    data: liveStrategyVolumeData,
    isPending: liveStrategyVolumePending,
    isSuccess: liveStrategyVolumeSuccess,
  } = useGetLiveStrategiesVolume();

  const {
    mutateAsync: getLogo,
    data: logoData,
    isPending: logoPending,
    isSuccess: logoSuccess,
  } = useGetLogos();
  const {
    data: PLData,
    isLoading: isPLLoading,
    isSuccess: isPLSuccess,
  } = useGetPL(user?.user_id, enviornment);

  const {
    mutateAsync: getExpiredStrats,
    data: expiredStratData,
    isPending: expiredStratLoading,
    isSuccess: expiredStratSuccess,
  } = useGetExpiredStrategies();

  const {
    data: allliveDeploymentData,
    isLoading: liveDataLoading,
    isSuccess: liveDataSuccess,
  } = useGetLiveDeploymentStats(user?.user_id);

  const {
    mutateAsync: getExpiredPLs,
    data: expiredPLsData,
    isPending: expiredPLsLoading,
    isSuccess: expiredPlsSuccess,
  } = useGetExpiredPLs();

  const { mutateAsync: undeployStrategy } = usePostUndeployLiveStrategy();
  const { mutateAsync: getSymbolData } = useGetSymbolData();

  const handleViewPerformanceClick = (
    deploymentId: string,
    strategyId: string
  ) => {
    setLoadingStates((prev: any) => ({ ...prev, [strategyId]: true }));
    router.push(
      `/forward-test-performance/${deploymentId}/${strategyId}?locale=${
        router.query.locale || "en"
      }`
    );
  };

  const getLogos = async (symbols: any) => {
    if (symbols?.length > 0) await getLogo({ symbols: symbols });
  };

  useEffect(() => {
    if (params.get("source") === "deploy") {
      setSCTab(SCANNER_TAB);
    }
  }, []);

  useEffect(() => {
    if (logoSuccess && logoData) {
      var logos_map = new Map();
      for (var item in logoData.data.data) {
        logos_map.set(item, logoData.data.data[item]);
      }
      setLogos(logos_map);
      setVirtualLogos(logos_map);
    }
  }, [logoPending, logoSuccess]);

  useEffect(() => {
    if (isPLSuccess && PLData) {
      const r = PLData;
      var p_l_map = new Map();
      let decision_map = new Map();
      let qty_map = new Map(),
        closed_orders_map = new Map(),
        realizedPnL_map = new Map(),
        currentPriceList = new Map(),
        order_price_list_map = new Map(),
        exchangeRate = new Map();
      for (var item in r.data?.order_price || {}) {
        p_l_map.set(item, r.data?.order_price?.[item]);
      }
      for (var item in r.data?.decision || {}) {
        decision_map.set(item, r.data?.decision?.[item]);
      }
      for (var item in r.data?.data || {}) {
        realizedPnL_map.set(item, r.data?.data?.[item]);
      }
      for (var item in r.data?.closed_orders || {}) {
        closed_orders_map.set(item, r.data?.closed_orders?.[item]);
      }
      for (var item in r.data?.order_price_list || {}) {
        order_price_list_map.set(item, r.data?.order_price_list?.[item]);
      }
      for (var item in r.data?.quantity || {}) {
        qty_map.set(item, r.data?.quantity?.[item]);
      }
      for (var item in r.data?.current_price_list || {}) {
        currentPriceList.set(item, r.data?.current_price_list?.[item]);
      }
      for (var item in r.data?.exchange_rate || {}) {
        exchangeRate.set(item, r.data?.exchange_rate?.[item]);
      }
      if (enviornment == "live") {
        setDecisionLive(decision_map);
        setQtyLive(qty_map);
        setRealizedPnLLive(realizedPnL_map);
        setOrderPriceListLive(order_price_list_map);
        setCurrentPriceListLive(currentPriceList);
        setExchangeRate(exchangeRate);
      }
    }
  }, [isPLLoading, isPLSuccess, PLData]);

  useEffect(() => {
    if (expiredStratSuccess && expiredStratData) {
      const strategies = expiredStratData.data.data;
      getPLs(strategies);
      const uniqueSymbols = Array.from(
        new Set(
          strategies.map((item: any) => item.deployment_meta.strategy.symbol)
        )
      );
      getLogos(uniqueSymbols);
      setExpiredStrategies(strategies);
      setExpiredVirtualStrategiesCount(expiredStratData.data.total);
      setExpiredLiveStrategiesCount(expiredStratData.data.total);
    }
  }, [expiredStratLoading, expiredStratSuccess, expiredStratData]);

  useEffect(() => {
    if (expiredPlsSuccess && expiredPLsData) {
      const expPl = new Map(Object?.entries?.(expiredPLsData));
      setExpiredPLs(expPl);
    }
  }, [expiredPLsData, expiredPlsSuccess, expiredPLsLoading]);

  useEffect(() => {
    if (liveDeploymentSuccess && liveDeploymentData) {
      setLiveTableDataLoader(false);
      setLiveTableData(liveDeploymentData.data.items);
      getAllLiveBrokerStrategiesOrderPosition(liveDeploymentData.data.items);
      setLiveTableCount(liveDeploymentData.data.total);
      let data = liveDeploymentData.data?.items.map((item: any, i: number) => {
        return item.deployment_meta.strategy.symbol;
      });
      //@ts-ignore
      let uniqueSymbols = [...new Set(data)];
      getLogos(uniqueSymbols);
    }
  }, [liveDeploymentSuccess, liveDeploymentLoading, liveDeploymentData]);

  useEffect(() => {
    if (monitorDeploymentSuccess && monitorDeploymentData) {
      const d = monitorDeploymentData?.data?.last_30_trades.sort(
        (a: any, b: any) =>
          parseFloat(a.trade_closed_at) - parseFloat(b.trade_closed_at)
      );
      setMonthlyData(d);
      setChartData(monitorDeploymentData?.data);
      setLatencyData(monitorDeploymentData?.data?.latency_dict);
    }
  }, [monitorDeploymentSuccess, monitorDeploymentLoading]);

  useEffect(() => {
    if (orderStatusSuccess && orderStatusData) {
      setLiveOrderPosition(orderStatusData.data);
    }
  }, [orderStatusPending, orderStatusData, orderStatusSuccess]);

  useEffect(() => {
    if (liveStrategyVolumeSuccess && liveStrategyVolumeData) {
      let vol: Record<string, number> = {};
      liveStrategyVolumeData.data.forEach((item: Record<string, number>) => {
        Object.entries(item).forEach(([key, value]) => {
          vol[key] = value;
        });
      });
      setVolume(vol);
    }
  }, [
    liveStrategyVolumeData,
    liveStrategyVolumePending,
    liveStrategyVolumeSuccess,
  ]);

  const getAllLiveBrokerStrategiesOrderPosition = async (data: any) => {
    await getOrderStatus({ user_id: user?.user_id, data: data });
    await getLiveStrategyVolume({ user_id: user?.user_id, data: data });
  };

  const onPioDataRec = useCallback((data: PIOAggregates) => {
    const now = Date.now();
    lastFetchTime.current = now;

    const getKey = (data: PIOAggregates): string | undefined => {
      if ("sym" in data) {
        return (data as PIOAggregatesPerSecond).sym;
      }
      if ("pair" in data) {
        return (data as PIOCryptoAggregatesPerSecond).pair;
      }
      if ("val" in data) {
        return (data as PIOFairMarketValue).val?.toString(); // assuming val is a number — adjust if needed
      }
      return undefined;
    };

    const key = getKey(data);
    if (key) {
      setPioData((prev) => ({
        ...prev,
        [key]: data,
      }));
    }
  }, []);

  useEffect(() => {
    polygonSocket.on("connect", () => {
      polygonSocket.emit(PIO_CONST.EVENT_NAME.SUBSCRIBE, {
        symbols: pioDataRef.current,
        type: PIO_CONST.SUBS_TYPE.FMV,
      } as SIOSubscription);
      polygonSocket.emit(PIO_CONST.EVENT_NAME.SUBSCRIBE, {
        symbols: pioDataRef.current,
        type: PIO_CONST.SUBS_TYPE.BLOFIN,
      } as SIOSubscription);
      polygonSocket.emit(PIO_CONST.EVENT_NAME.SUBSCRIBE, {
        symbols: pioDataRef.current,
        type: PIO_CONST.SUBS_TYPE.AGGREGATOR_FX,
      } as SIOSubscription);
    });
    polygonSocket.on(PIO_CONST.SUBS_TOPICS.FMV, onPioDataRec);
    polygonSocket.on(PIO_CONST.SUBS_TOPICS.AGGREGATOR_FX, onPioDataRec);
    polygonSocket.on(PIO_CONST.SUBS_TOPICS.AGGREGATOR_CRYPTO, onPioDataRec);
    return () => {
      polygonSocket.off(PIO_CONST.SUBS_TOPICS.FMV, onPioDataRec);
      polygonSocket.off(PIO_CONST.SUBS_TOPICS.AGGREGATOR_FX, onPioDataRec);
      polygonSocket.off(PIO_CONST.SUBS_TOPICS.AGGREGATOR_CRYPTO, onPioDataRec);
    };
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const u = JSON.parse(localStorage.getItem("user-info")!);
      const socket = io("https://wsstest.trylevel2.com:3222", {
        auth: {
          secret: generateTokenForSocket,
        },
      });
      socket.emit("addUserToRoom", "web.event.deployment");
      socket.on("getMessageFromServer", (data) => {
        if (!data?.is_delete) window.location.reload();
      });
    }
  }, []);

  const liveStrategyUndeploy = async (val: string) => {
    setLoading(true);
    await undeployStrategy({ userId: user?.user_id || "", strategy_id: val });
    await refetchLiveDeploymen();
    setLiveTableData(
      liveTableData.filter(
        (item: any) => item.deployment_meta.strategy.id != val
      )
    );
    getAllLiveBrokerStrategiesOrderPosition(
      liveTableData.filter(
        (item: any) => item.deployment_meta.strategy.id != val
      )
    );
    setLoading(false);
  };

  const changeLiveCurrentPage = (val: number) => {
    setLiveTableCurrent(val);
  };

  const liveDataOnPageChange = (val: number) => {
    setLiveTableCurrent(val);
    changeLiveCurrentPage(val);
  };

  const changeExpiredVirtualStrategiesPage = async (val: number) => {
    setExpiredVirtualStrategiesCurrent(val);
    await getExpiredStrats({
      user_id: user?.user_id,
      type: enviornment,
      offset: (val - 1) * expiredStrategiesLimit,
    });
  };

  const expiredVirtualOnPageChange = (val: number) => {
    setExpiredVirtualStrategiesCurrent(val);
    changeExpiredVirtualStrategiesPage(val);
  };

  const changeExpiredLiveStrategiesPage = async (val: number) => {
    setExpiredLiveStrategiesCurrent(val);
    await getExpiredStrats({
      user_id: user?.user_id,
      type: enviornment,
      offset: (val - 1) * expiredStrategiesLimit,
    });
  };

  const getPLs = async (data: any) => {
    const deploymentIds = data.map((d: any) => d.deployment_meta.id).toString();
    await getExpiredPLs({
      user_id: user?.user_id,
      type: enviornment,
      deploymentIds: deploymentIds,
    });
  };

  const showExpired = async (type: string) => {
    setLoading(true);
    setExpiredStrategyModal(true);
    await getExpiredStrats({ user_id: user?.user_id, type: enviornment });
    setViewType(type);
    setLoading(false);
  };

  const changeTab = (key: string) => {
    setSCTab(key);
  };

  const copyToClipboard = (strId: string) => {
    navigator.clipboard.writeText(strId);
    setCopiedStrategyId(strId);
    setTimeout(() => {
      setCopiedStrategyId("");
    }, 1500);
  };

  const deploymentTabs = [
    {
      label: "Live",
      brokerId: 8,
      brokerName: capitalizeFirstLetter(CURRENT_BROKER_NAME),
      disabled: false,
      icon: BsFillLightningChargeFill,
      count:
        allliveDeploymentData?.data?.deployed_counts_per_broker?.[
          CURRENT_BROKER_ID
        ] ?? 0,
    },
    {
      label: "Scanners",
      brokerId: 6,
      disabled: false,
      icon: BiRadar,
      count: 0,
    },
  ];
  if (!session && !user) {
    return <></>;
  }

  return (
    <>
      <div className="flex flex-row flex-wrap my-5">
        <ViewModal
          isOpen={showModal}
          onRequestClose={() => setShowModal(false)}
          selected={selected}
          showValues={true}
          token={user?.token}
        />
        <UndeployModal
          isOpen={undeployData.open}
          onClose={() => setUnDeployData({ open: false, strategyId: "" })}
          liveStrategyUndeploy={() =>
            liveStrategyUndeploy(undeployData.strategyId)
          }
        />
        <Card className={"w-full"}>
          <div className="rounded-lg">
            <CardHeader>
              <CardTitle>
                <div className="text-2xl font-bold tracking-tight">
                  {t("monitordepl")}
                </div>
              </CardTitle>
            </CardHeader>

            <div className="flex gap-4 flex-col h-fit lg:flex-row lg:h-56 mb-6 p-6 w-full">
              <div className="w-full h-50 border rounded-lg p-1 px-2 h-52 lg:max-w-80 xl:max-w-96">
                <div className="text-foreground flex flex-col gap-1 items-start">
                  <span className="text-sm font-bold text-muted-foreground px-2 my-1">
                    {ct("Average Latency per order")}
                  </span>
                  <div className="w-full  h-36">
                    <ResponsiveContainer width="100%" height="100%">
                      <LineChart
                        data={Object.entries(latencyData || {}).map(
                          ([timestamp, value]) => ({
                            timestamp: Number(timestamp),
                            time: new Date(
                              Number(timestamp) * 1000
                            ).toLocaleTimeString("en-US", { timeZone: "UTC" }),
                            value: Number(value) || 0,
                          })
                        )}
                        margin={{ top: 15, right: 20, bottom: 0, left: 0 }}
                      >
                        <defs>
                          <linearGradient
                            id="lineGradient"
                            x1="0"
                            y1="0"
                            x2="1"
                            y2="0"
                          >
                            <stop offset="0%" stopColor={AccentColor.BLUE} />
                            <stop
                              offset="100%"
                              stopColor={"var(--foreground-red)"}
                            />
                          </linearGradient>
                        </defs>

                        <XAxis
                          dataKey="time"
                          tick={{ fontSize: 12 }}
                          tickLine={false}
                        />
                        <YAxis
                          tick={{ fontSize: 12 }}
                          tickLine={false}
                          label={{
                            value: "Latency(ms)",
                            angle: -90,
                            position: "insideBottomLeft",
                            offset: 15,
                          }}
                        />

                        <Line
                          type="linear"
                          dataKey="value"
                          stroke="url(#lineGradient)"
                          strokeWidth={2}
                          dot={false}
                        />
                        <RechartsTooltip
                          cursor={false}
                          labelFormatter={(label: any, payload: any) => {
                            const timestamp = payload[0]?.payload?.timestamp;
                            return `Date: ${formatDate(
                              timestamp * 1000,
                              "DD-MMM-YY hh:mm"
                            )} UTC`;
                          }}
                          formatter={(value: any) => {
                            const latency = Number(value);
                            const latencyColor = fetchColor({
                              positive: "var(--foreground-green)",
                              negative: "var(--foreground-red)",
                            })[latency > 150 ? "negative" : "positive"];

                            return [
                              <span
                                className="font-bold"
                                key="tooltip"
                                style={{ color: latencyColor }}
                              >{`${value}ms`}</span>,
                              "Latency",
                            ];
                          }}
                          contentStyle={{
                            backgroundColor: "transparent",
                            border: "none",
                            fontSize: "12px",
                            padding: "10px",
                            color: "white",
                          }}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                  <div className="w-full flex items-center justify-center">
                    <span className="text-xs text-muted-foreground">
                      Server(s) location:{" "}
                      <span className="text-[#2252CC]">Mumbai (Asia)</span>
                    </span>
                  </div>
                </div>
              </div>
              <SlipageChart />
              <div className="flex flex-grow  w-full min-h-52 h-52">
                <MonthlyStrategyPerformance t={t} monthlyData={monthlyData} />
              </div>
              <div className="flex flex-col h-52 gap-2 min-w-[200px] w-full lg:w-fit items-center justify-between rounded-lg border p-2">
                <div className="flex flex-col gap-2 items-center justify-center">
                  <p className="text-sm font-bold text-muted-foreground flex gap-1">
                    Total Trades Triggered
                    <span className="text-foreground">
                      <HoverCard openDelay={100}>
                        <HoverCardTrigger asChild>
                          <span>
                            <BiSolidHelpCircle size={12} />
                          </span>
                        </HoverCardTrigger>
                        <HoverCardContent>
                          {t(
                            "Calculation is based on closed trades. Open/floating positions are not included in this statistic"
                          )}
                        </HoverCardContent>
                      </HoverCard>
                    </span>
                  </p>
                  <p className="text-2xl font-bold">
                    {(chartData?.total_win?.[0]?.total_trades || 0) +
                      (chartData?.total_loss?.[0]?.total_trades || 0)}
                  </p>
                </div>
                <div className="flex flex-col items-center gap-2">
                  <p className="text-sm font-bold text-muted-foreground">
                    Realized PnL
                  </p>
                  <p
                    className={cn(
                      "text-2xl font-bold",
                      minFixedDecimal(
                        (chartData?.total_loss?.[0]?.total_loss_dollars || 0) +
                          (chartData?.total_win?.[0]?.total_win_dollars || 0),
                        DP22
                      ) > 0
                        ? "text-green-foreground"
                        : minFixedDecimal(
                            (chartData?.total_loss?.[0]?.total_loss_dollars ||
                              0) +
                              (chartData?.total_win?.[0]?.total_win_dollars ||
                                0),
                            DP22
                          ) < 0
                        ? "text-red-foreground"
                        : ""
                    )}
                  >
                    {(() => {
                      const totalValue =
                        (chartData?.total_loss?.[0]?.total_loss_dollars || 0) +
                        (chartData?.total_win?.[0]?.total_win_dollars || 0);
                      const { isNegative, value } = toNumberAndSign(
                        totalValue || 0
                      );
                      if (value === 0) {
                        return `$${value.toFixed(2)}`; // Display 0 without sign
                      }
                      return (
                        <>
                          {isNegative ? "-" : "+"}
                          {`$${value.toFixed(2)}`}
                        </>
                      );
                    })()}
                  </p>
                </div>
                <div></div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row sm:justify-between pl-6 pr-4 pb-6">
              <div className="flex flex-col grow w-full">
                {
                  <div className="flex flex-col sm:flex-row sm:justify-between pl-6 pr-4 pb-6">
                    <div className="flex flex-col grow">
                      <CardDescription>
                        <div className="mb-5 flex justify-between w-full clear-left">
                          <div className="text-xs sm:flex hidden">
                            {t("tradeTitle")}
                          </div>
                        </div>
                      </CardDescription>
                    </div>
                  </div>
                }
                <div className=" flex justify-center items-center sm:justify-start w-full mb-4 p-0">
                  <Tabs
                    onValueChange={(val) => changeTab(val)}
                    value={SCTab}
                    className="w-full  "
                  >
                    <TabsList className="px-1 h-auto">
                      {deploymentTabs.map((tab, index) => (
                        <Tooltip
                          key={tab.brokerId || index}
                          delayDuration={100}
                        >
                          <TooltipTrigger className="!grow">
                            <TabsTrigger
                              value={tab.brokerId}
                              disabled={tab?.disabled}
                              className={clsx(
                                "grow w-full flex items-center justify-center gap-2 font-medium py-2 px-6 rounded-md transition",
                                SCTab.toString() ===
                                  tab?.brokerId?.toString() &&
                                  "text-tl2-blue-base font-bold data-[state=active]:text-tl2-blue-base data-[state=active]:font-bold"
                              )}
                            >
                              {" "}
                              {tab?.icon && (
                                <tab.icon className="w-4 h-4 mr-2" />
                              )}
                              <span className="text-muted-foreground">
                                {t(tab.label)}
                              </span>
                              <span
                                className={clsx(
                                  "inline-flex items-center justify-center min-w-[1.25rem] h-[1.25rem] px-1.5 text-xs font-medium rounded-full bg-muted-foreground/15",
                                  SCTab.toString() ===
                                    tab?.brokerId?.toString() &&
                                    "text-tl2-blue-base font-bold data-[state=active]:text-tl2-blue-base data-[state=active]:font-bold"
                                )}
                              >
                                {tab.count ?? 0}
                              </span>
                            </TabsTrigger>
                          </TooltipTrigger>
                          {tab.disabled && (
                            <TooltipContent>
                              {t(`${tab.label} trading disabled`)}
                            </TooltipContent>
                          )}
                        </Tooltip>
                      ))}
                    </TabsList>
                  </Tabs>

                  {SCTab !== SCANNER_TAB && (
                    <div className="flex justify-center items-start">
                      <div className=" ">
                        <Button
                          variant="secondary"
                          onClick={() => {
                            showExpired(SCTab);
                          }}
                          className="w-fit lg:w-[100%]"
                        >
                          {t("Trade history")}
                        </Button>
                      </div>
                    </div>
                  )}
                </div>

                <div className="w-full max-w-[100%] ">
                  {SCTab == SCANNER_TAB && (
                    <DeployedScannersTable userInfo={user} />
                  )}
                  {!liveTableDataLoader && SCTab != SCANNER_TAB ? (
                    <>
                      {loading ? (
                        <Loader text={ct("LoadingWait")} />
                      ) : (
                        <div className="overflow-y-visible  relative z-[1] max-w-[100%] overflow-auto">
                          <Table className="w-full min-w-fit">
                            <TableHeader>
                              <TableRow>
                                <TableHead className="whitespace-nowrap min-w-[305px] 2xl:min-w-[260px]">
                                  {t("table.head.strategy")}
                                </TableHead>
                                <TableHead className="whitespace-nowrap"></TableHead>

                                <TableHead className="whitespace-nowrap">
                                  {t("table.head.asset")}
                                </TableHead>
                                <TableHead className="flex gap-1 min-w-fit whitespace-nowrap w-32 p-4">
                                  {t("unrealizedPnL")}
                                  <div className="cursor-pointer">
                                    <HoverCard openDelay={100}>
                                      <HoverCardTrigger
                                        asChild
                                        className="inline-block"
                                      >
                                        <span>
                                          <BiSolidHelpCircle size={16} />
                                        </span>
                                      </HoverCardTrigger>
                                      <HoverCardContent className="whitespace-normal">
                                        {t(
                                          "matching mechanism is price priority and time priority"
                                        )}
                                      </HoverCardContent>
                                    </HoverCard>
                                  </div>
                                </TableHead>
                                <TableHead className="whitespace-nowrap min-w-[130px]">
                                  {t("table.head.realizedPnl")}
                                </TableHead>
                                <TableHead className="whitespace-nowrap">
                                  {t("Current Price")}
                                </TableHead>
                                <TableHead className="whitespace-nowrap">
                                  {t("Side")}
                                </TableHead>
                                {/* <TableHead className="whitespace-nowrap">
                                  {t("table.head.brokerName")}
                                </TableHead> */}
                                <TableHead className="flex gap-1 min-w-fit whitespace-nowrap w-32 p-4 ">
                                  {t("Qty")}
                                  <div className="cursor-pointer ">
                                    <HoverCard openDelay={100}>
                                      <HoverCardTrigger
                                        asChild
                                        className="inline-block "
                                      >
                                        <span>
                                          <BiSolidHelpCircle size={16} />
                                        </span>
                                      </HoverCardTrigger>
                                      <HoverCardContent className="whitespace-normal">
                                        {t(
                                          "Total of all open and closed positions"
                                        )}
                                      </HoverCardContent>
                                    </HoverCard>
                                  </div>
                                </TableHead>
                                <TableHead className="whitespace-nowrap">
                                  {t("table.head.deployed")}
                                </TableHead>
                                <TableHead className="whitespace-nowrap">
                                  {t("table.head.expiry")}
                                </TableHead>
                                <TableHead className="flex gap-1 items-center whitespace-nowrap">
                                  <span>{t("table.head.manage")}</span>
                                  <div className="cursor-pointer">
                                    <HoverCard openDelay={100}>
                                      <HoverCardTrigger
                                        asChild
                                        className="inline-block"
                                      >
                                        <span>
                                          <BiSolidHelpCircle size={16} />
                                        </span>
                                      </HoverCardTrigger>
                                      <HoverCardContent className="whitespace-normal">
                                        {t(
                                          "If you close any trades manually remember to check and update the orders if necessary, so the trade results are in sync."
                                        )}
                                      </HoverCardContent>
                                    </HoverCard>
                                  </div>
                                </TableHead>
                              </TableRow>
                            </TableHeader>
                            <TableBody>
                              {liveTableData.length == 0 ? (
                                <TableRow>
                                  <TableCell colSpan={10}>
                                    <div className="w-full flex justify-center">
                                      <div className="flex justify-center text-sm text-muted-foreground text-center">
                                        {t("No deployments found")}
                                      </div>
                                    </div>
                                  </TableCell>
                                </TableRow>
                              ) : (
                                ""
                              )}

                              {liveTableData.map((data: any, i: number) => {
                                let add = [];
                                const symbol =
                                  data?.deployment_meta?.strategy?.symbol || "";
                                const { DPPs, DPs } = getDPFor(symbol);
                                if (
                                  data.deployment_meta.strategy.add_ons != null
                                ) {
                                  add = Object.values(
                                    JSON.parse(
                                      data.deployment_meta.strategy.add_ons
                                    )
                                  ).filter((item: any) => item !== null);
                                }
                                const strId =
                                  data.deployment_meta.strategy.id.toString();
                                const pioDataEntry =
                                  pioData[stripPioSymbolFromSymbol(symbol)];

                                const isFairMarketValue = (
                                  data: any
                                ): data is PIOFairMarketValue => {
                                  return data && "val" in data;
                                };

                                let cP = toNumberOrNull(
                                  (pioDataEntry as PIOAggregates)?.c ??
                                    currentPriceListLive?.get?.(strId)
                                );

                                const liveData = toNumberOrNull(
                                  isFairMarketValue(pioDataEntry)
                                    ? pioDataEntry.val
                                    : pioDataEntry?.c
                                );

                                let orderPriceList =
                                  orderPriceListLive.get(strId);
                                const dcsn = decisionLive.get(strId);
                                const _qty = qtyLive.get(strId);
                                const exchange = exchangeRate.get(strId);
                                const orderPosition = liveOrderPosition?.find(
                                  (inst: any) =>
                                    inst.strategy_id ===
                                    data.deployment_meta.strategy.id
                                );
                                const { isStopLossPercent, ...decision } =
                                  getOrderType(data);
                                const rPnL = toNumberOrNull(
                                  realizedPnLLive.get(strId),
                                  "--"
                                );
                                const trPnL =
                                  rPnL === "--"
                                    ? "--"
                                    : "$" + minFixedDecimal(rPnL, DP22);
                                const qty = toNumberOrNull(_qty);
                                const days: any = {
                                  "1": t("Mon"),
                                  "2": t("Tue"),
                                  "3": t("Wed"),
                                  "4": t("Thu"),
                                  "5": t("Fri"),
                                  "6": t("Sat"),
                                  "0": t("Sun"),
                                };
                                const addOns = JSON.parse(
                                  data?.deployment_meta?.strategy?.add_ons
                                );
                                const [day, month, year] =
                                  addOns?.strategy_expiration
                                    ? addOns?.strategy_expiration
                                        ?.split("/")
                                        .map(Number)
                                    : new Array(3).fill("NA");

                                const metaData =
                                  data?.deployment_meta?.meta_data &&
                                  JSON.parse(
                                    data?.deployment_meta?.meta_data.replace(
                                      /\\/g,
                                      ""
                                    )
                                  );
                                const canvasData = data?.deployment_meta
                                  ?.strategy?.canvas_data
                                  ? JSON.parse(
                                      data?.deployment_meta?.strategy
                                        ?.canvas_data
                                    )
                                  : {};

                                const nodes = canvasData?.filter?.(
                                  (data: any) => data.type === "selectorNode"
                                );

                                const edges = canvasData?.filter?.(
                                  (data: any) => data.type === "buttonedge"
                                );
                                const totalUnrealizedPnl =
                                  orderPriceList?.reduce(
                                    (
                                      sum: number,
                                      order: any,
                                      index: number
                                    ) => {
                                      const filled_price = order;
                                      const decision = dcsn;
                                      console.log(
                                        "current",
                                        cP,
                                        filled_price,
                                        decision,
                                        qty,
                                        exchange
                                      );
                                      console.log("qty inner", qty);

                                      const result =
                                        (calculateDifference(
                                          cP,
                                          filled_price,
                                          decision
                                        ) *
                                          qty) /
                                        exchange;
                                      return sum + result;
                                    },
                                    0
                                  ) ?? "--";

                                return (
                                  <>
                                    <TableRow key={"table2-" + i}>
                                      <TableCell
                                        className="whitespace-nowrap  max-w-[100px]"
                                        onClick={() =>
                                          router.push(
                                            `/forward-test-performance/${
                                              data?.deployment_meta?.id
                                            }/${
                                              data?.deployment_meta?.strategy.id
                                            }?locale=${
                                              router.query.locale || "en"
                                            }`
                                          )
                                        }
                                      >
                                        <span className="flex  flex-row justify-between items-center w-full">
                                          <div>
                                            <span
                                              className="cursor-pointer  transition-all duration-500 truncate"
                                              title={
                                                data.deployment_meta.strategy
                                                  .strategy_name
                                              }
                                            >
                                              {
                                                data.deployment_meta.strategy
                                                  .strategy_name
                                              }
                                              {+data.is_copied ? (
                                                <div className="my-2">
                                                  <span className="text-xs text-muted-foreground">
                                                    {t("table.body.copied")}
                                                  </span>
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                            <RunningStrategyCard></RunningStrategyCard>

                                            <div className="flex gap-2  text-xs text-muted-foreground items-center">
                                              {t("Strategy")}: {strId}
                                              <div
                                                className="flex flex-row gap-0"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  copyToClipboard(strId);
                                                }}
                                              >
                                                <Button
                                                  disabled={isCopied}
                                                  variant="ghost"
                                                  size="icon"
                                                >
                                                  {copiedStrategyId ===
                                                  strId ? (
                                                    <MdDone />
                                                  ) : (
                                                    <FiCopy />
                                                  )}
                                                </Button>
                                              </div>
                                            </div>
                                          </div>

                                          <div className="flex w-[75px] gap-1 justify-end items-center">
                                            <HoverCard>
                                              <HoverCardTrigger>
                                                {data?.deployment_meta.strategy
                                                  .add_ons != null &&
                                                  data?.deployment_meta.strategy
                                                    .add_ons != "{}" &&
                                                  add?.length > 0 && (
                                                    <div className="flex items-center overflow-hidden cursor-pointer transition-all duration-1000 hover:grayscale ">
                                                      <IoExtensionPuzzleSharp />
                                                    </div>
                                                  )}
                                              </HoverCardTrigger>
                                              <HoverCardContent className="w-[350px] p-0">
                                                <div className="font-bold px-4 text-lg my-2">
                                                  {t(
                                                    "Strategy add-ons enabled"
                                                  )}
                                                </div>
                                                <Table>
                                                  <TableBody>
                                                    <TableRow className="text-xs py-0">
                                                      <TableCell className="text-xs py-0.5 whitespace-normal">
                                                        {t("Day Switch")}{" "}
                                                        {"(on)"}
                                                      </TableCell>
                                                      <TableCell className="text-xs flex gap-2 py-0.5">
                                                        {addOns?.day_switch
                                                          ? JSON.parse(
                                                              addOns?.day_switch
                                                            )?.map(
                                                              (
                                                                item: any,
                                                                index: number
                                                              ) => (
                                                                <Badge
                                                                  key={index}
                                                                  variant="outline"
                                                                >
                                                                  {days?.[item]}
                                                                </Badge>
                                                              )
                                                            )
                                                          : "NA"}
                                                      </TableCell>
                                                    </TableRow>
                                                    <TableRow className="text-xs py-0">
                                                      <TableCell className="text-xs py-0.5 whitespace-normal">
                                                        {t(
                                                          "Strategy Expiration"
                                                        )}
                                                      </TableCell>
                                                      <TableCell className="text-xs flex gap-2 py-0.5 whitespace-nowrap">
                                                        {addOns?.strategy_expiration
                                                          ? formatDate(
                                                              new Date(
                                                                year,
                                                                month - 1,
                                                                day
                                                              ),
                                                              "DD-MMM-YY"
                                                            )
                                                          : "NA"}
                                                      </TableCell>
                                                    </TableRow>
                                                    <TableRow className="text-xs py-0">
                                                      <TableCell className="text-xs py-0.5 whitespace-normal">
                                                        {t(
                                                          "Number of trades switch"
                                                        )}
                                                      </TableCell>
                                                      <TableCell className="text-xs flex gap-2 py-0.5">
                                                        {addOns?.killSwitch
                                                          ? addOns?.killSwitch
                                                          : "NA"}
                                                      </TableCell>
                                                    </TableRow>
                                                    <TableRow className="text-xs py-0">
                                                      <TableCell
                                                        className="text-xs py-0.5 whitespace-normal
                                                "
                                                      >
                                                        {t(
                                                          "Profit satisfaction shutdown"
                                                        )}
                                                      </TableCell>
                                                      <TableCell className="text-xs flex gap-2 py-0.5">
                                                        {addOns?.profit
                                                          ? "$" + addOns?.profit
                                                          : "NA"}
                                                      </TableCell>
                                                    </TableRow>
                                                    <TableRow className="text-xs py-0">
                                                      <TableCell
                                                        className="text-xs py-0.5 whitespace-normal
                                                "
                                                      >
                                                        {t(
                                                          "Loss realization shutdown"
                                                        )}
                                                      </TableCell>
                                                      <TableCell className="text-xs flex gap-2 py-0.5">
                                                        {addOns?.loss
                                                          ? "$" + addOns?.loss
                                                          : "NA"}
                                                      </TableCell>
                                                    </TableRow>
                                                    <TableRow className="text-xs py-0">
                                                      <TableCell className="text-xs py-0.5">
                                                        {t("Time Switch")}{" "}
                                                        {"(off)"}
                                                      </TableCell>
                                                      <TableCell className="text-xs py-0.5">
                                                        <div className="flex gap-4">
                                                          <span>
                                                            {t("Start Time")}
                                                          </span>
                                                          <span>
                                                            {addOns?.startTime
                                                              ? addOns?.startTime
                                                              : "NA"}
                                                          </span>
                                                        </div>
                                                        <div className="flex gap-4">
                                                          <span>
                                                            {t("End Time")}
                                                          </span>
                                                          <span>
                                                            {addOns?.endTime
                                                              ? addOns?.endTime
                                                              : "NA"}
                                                          </span>
                                                        </div>
                                                        <div className="flex gap-4">
                                                          <span>
                                                            {t("Timezone")}
                                                          </span>
                                                          <span>
                                                            {addOns?.timezone
                                                              ? addOns?.timezone
                                                              : "NA"}
                                                          </span>
                                                        </div>
                                                      </TableCell>
                                                    </TableRow>
                                                  </TableBody>
                                                </Table>
                                              </HoverCardContent>
                                            </HoverCard>
                                            {(orderPosition?.order_status ===
                                              "open" ||
                                              orderPosition?.order_status ===
                                                "inprogress") && (
                                              <div
                                                title={t("positionOpen")}
                                                className="cursor-pointer"
                                              >
                                                <FaRegFileAlt className="text-green-foreground" />
                                              </div>
                                            )}
                                            <div
                                              title={t("View performance")}
                                              className="flex justify-center items-center"
                                            >
                                              <MdOutlineKeyboardArrowRight className="cursor-pointer text-destructive text-2xl font-extrabold" />
                                            </div>
                                          </div>
                                        </span>
                                      </TableCell>
                                      <TableCell>
                                        <div
                                          className="mr-8 text-sm font-bold cursor-pointer text-muted-foreground hover:text-[#545454]"
                                          onClick={() => {
                                            setSelected({
                                              nodes,
                                              edges,
                                              symbol:
                                                data?.deployment_meta?.strategy
                                                  ?.symbol,
                                              timeframe:
                                                data?.deployment_meta?.strategy
                                                  ?.timeframe,
                                            });
                                            setShowModal(true);
                                          }}
                                        >
                                          <div className="flex items-center">
                                            <div>
                                              <Eye className="w-[15px]" />
                                            </div>
                                            <div className="ml-1">
                                              {t("View")}
                                            </div>
                                          </div>
                                        </div>
                                      </TableCell>
                                      <TableCell className="py-4 pl-4">
                                        <div className="flex flex-row space-x-2 whitespace-nowrap justify-start items-center">
                                          {logos &&
                                          logos.get(
                                            data.deployment_meta.strategy.symbol
                                          ) !== undefined ? (
                                            <>
                                              <img
                                                src={logos.get(
                                                  data.deployment_meta.strategy
                                                    .symbol
                                                )}
                                                style={{
                                                  maxHeight: "30px",
                                                  maxWidth: "30px",
                                                }}
                                                alt={
                                                  data.deployment_meta.strategy
                                                    .symbol
                                                }
                                              />
                                              <span className="">
                                                {
                                                  data.deployment_meta.strategy
                                                    .symbol
                                                }
                                              </span>
                                            </>
                                          ) : (
                                            <>
                                              <img
                                                src={
                                                  darkTheme
                                                    ? "/images/logos/Symbol_Dark.png"
                                                    : "/images/logos/Symbol_Light-30.png"
                                                }
                                                style={{
                                                  maxHeight: "30px",
                                                  maxWidth: "30px",
                                                }}
                                                alt={
                                                  data.deployment_meta.strategy
                                                    .symbol
                                                }
                                              />
                                              <span className="">
                                                {
                                                  data.deployment_meta.strategy
                                                    .symbol
                                                }
                                              </span>
                                            </>
                                          )}
                                        </div>
                                      </TableCell>

                                      <TableCell
                                        className={cn(
                                          totalUnrealizedPnl === "--"
                                            ? "text-center"
                                            : totalUnrealizedPnl > 0
                                            ? "text-green-foreground"
                                            : totalUnrealizedPnl < 0
                                            ? "text-red-foreground"
                                            : ""
                                        )}
                                      >
                                        {totalUnrealizedPnl === "--"
                                          ? totalUnrealizedPnl
                                          : formatCurrency(
                                              totalUnrealizedPnl,
                                              DP44.maxDecimalPlaces
                                            )}
                                      </TableCell>

                                      <TableCell
                                        className={cn(
                                          rPnL === "--"
                                            ? ""
                                            : rPnL > 0
                                            ? "text-green-foreground"
                                            : rPnL < 0
                                            ? "text-red-foreground"
                                            : ""
                                        )}
                                      >
                                        {trPnL}
                                      </TableCell>
                                      <TableCell>
                                        {minFixedDecimal(
                                          toNumberOrNull(
                                            cP,
                                            "NA (Market Closed)"
                                          ),
                                          DPPs
                                        )}
                                      </TableCell>

                                      <TableCell className="py-4 pl-4 ">
                                        {decision?.allDecision ==
                                        "Smart Buy/Smart Exit Position"
                                          ? "Smart Buy"
                                          : decision?.allDecision}
                                      </TableCell>

                                      {/* <TableCell className="py-4  pl-4 ">
                                        {getIsCrypto(
                                          data?.deployment_meta?.strategy
                                            ?.symbol
                                        )
                                          ? "Blofin"
                                          : "Alpaca"}
                                      </TableCell> */}
                                      <TableCell className="py-4  pl-4 ">
                                        {minFixedDecimal(
                                          volume?.[
                                            data?.deployment_meta?.strategy?.id
                                          ],
                                          {
                                            minDecimalPlaces: 0,
                                            maxDecimalPlaces: 4,
                                          },
                                          "N/A"
                                        )}
                                      </TableCell>
                                      <TableCell className="py-4 pl-4 whitespace-nowrap">
                                        {formatEpochDate(
                                          data.epoch_created_at,
                                          "DD-MMM-YY"
                                        )}
                                      </TableCell>
                                      <TableCell className="py-4 pl-4 whitespace-nowrap">
                                        {addOns?.strategy_expiration
                                          ? formatDate(
                                              new Date(year, month - 1, day),
                                              "DD-MMM-YY"
                                            )
                                          : formatEpochDate(
                                              parseInt(data.epoch_created_at) +
                                                expiry,
                                              "DD-MMM-YY"
                                            )}
                                      </TableCell>
                                      <TableCell className="w-fit lg:w-[184px] lg:min-w-[184px]">
                                        <div className="flex lg:w-[100%]">
                                          <Scheduler
                                            epochTime={+data?.epoch + 60}
                                            afterEnd={
                                              <div className="flex flex-col gap-2 w-full justify-end">
                                                <Button
                                                  disabled={
                                                    loadingStates[
                                                      data.deployment_meta
                                                        .strategy.id
                                                    ]
                                                  }
                                                  variant="outline"
                                                  className="lg:w-[100%]"
                                                  onClick={() => {
                                                    handleViewPerformanceClick(
                                                      data.deployment_meta.id,
                                                      data.deployment_meta
                                                        .strategy.id
                                                    );
                                                  }}
                                                >
                                                  {t("View Performance")}
                                                  {loadingStates[
                                                    data.deployment_meta
                                                      .strategy.id
                                                  ] && (
                                                    <div className="w-full flex justify-center items-center py-1">
                                                      <Loader />
                                                    </div>
                                                  )}
                                                </Button>

                                                <Button
                                                  variant="secondary"
                                                  className="lg:w-[100%]"
                                                  onClick={() => {
                                                    setUnDeployData({
                                                      open: true,
                                                      strategyId:
                                                        data.deployment_meta
                                                          .strategy.id,
                                                    });
                                                  }}
                                                >
                                                  {t("table.body.undeploy")}
                                                </Button>
                                              </div>
                                            }
                                          />
                                        </div>
                                      </TableCell>
                                    </TableRow>
                                  </>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </div>
                      )}
                      {
                        <Pagination
                          totalCount={liveTableCount}
                          currentPage={liveTableCurrent}
                          changePage={liveDataOnPageChange}
                          limit={liveDataLimit}
                        />
                      }
                    </>
                  ) : SCTab == 6 ? (
                    <></>
                  ) : (
                    <div className="flex flex-row justify-center items-center">
                      <Loader text={ct("LoadingWait")} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>

      <Dialog
        open={expiredStrategyModal}
        onOpenChange={(open: any) => {
          setExpiredStrategyModal(open);
        }}
      >
        <DialogContent className="h-fit max-w-[1000px] max-h-[650px] sm:max-h-[350px] lg:max-h-mcg overflow-y-auto">
          <DialogHeader>
            <DialogTitle>{t("Trade history")}</DialogTitle>
          </DialogHeader>
          {expiredStrategies.length > 0 && (
            <Table className="w-full min-w-fit">
              <TableHeader>
                <TableRow>
                  <TableHead>{t("table.head.strategyName")}</TableHead>
                  <TableHead className="flex gap-1 p-4 min-w-fit w-36">
                    {t("table.head.realizedPnl")}
                  </TableHead>
                  <TableHead>{t("table.head.asset")}</TableHead>
                  <TableHead>{t("table.head.timeframe")}</TableHead>
                  <TableHead>{t("Deployed")}</TableHead>
                  <TableHead>{t("expired")}</TableHead>
                  <TableHead>{t("table.head.action")}</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {expiredStrategies.map((s: any, i: number) => {
                  if (s.deployment_meta.strategy.symbol == "") {
                    return false;
                  }
                  let pnl = expiredPLs.get(s.deployment_meta.id.toString());
                  return (
                    <TableRow key={"s-" + i}>
                      <TableCell
                        title={s.deployment_meta.strategy.strategy_name}
                      >
                        {s.deployment_meta.strategy.strategy_name}
                      </TableCell>
                      {pnl === undefined ? (
                        <TableCell>{t("marketClosed")}</TableCell>
                      ) : (
                        <TableCell
                          className={
                            pnl >= 0
                              ? "text-green-foreground"
                              : "text-red-foreground"
                          }
                        >
                          {pnl === null ? "-" : formatCurrency(pnl)}
                        </TableCell>
                      )}
                      <TableCell>
                        {viewType == "virtual" ? (
                          <div className="flex space-x-2 items-center">
                            {virtualLogos &&
                            virtualLogos.get(
                              s.deployment_meta.strategy.symbol
                            ) !== undefined ? (
                              <>
                                <img
                                  src={virtualLogos.get(
                                    s.deployment_meta.strategy.symbol
                                  )}
                                  style={{
                                    maxHeight: "30px",
                                    maxWidth: "30px",
                                  }}
                                  alt={s.deployment_meta.strategy.symbol}
                                />
                                <span>{s.deployment_meta.strategy.symbol}</span>
                              </>
                            ) : (
                              <>
                                <img
                                  src={
                                    darkTheme
                                      ? "/images/logos/Symbol_Dark.png"
                                      : "/images/logos/Symbol_Light-30.png"
                                  }
                                  style={{
                                    maxHeight: "30px",
                                    maxWidth: "30px",
                                  }}
                                  alt={s.deployment_meta.strategy.symbol}
                                />
                                <span>{s.deployment_meta.strategy.symbol}</span>
                              </>
                            )}
                          </div>
                        ) : (
                          <div className="flex space-x-2 items-center">
                            {logos &&
                            logos.get(s.deployment_meta.strategy.symbol) !==
                              undefined ? (
                              <>
                                <img
                                  src={logos.get(
                                    s.deployment_meta.strategy.symbol
                                  )}
                                  style={{
                                    maxHeight: "30px",
                                    maxWidth: "30px",
                                  }}
                                  alt={s.deployment_meta.strategy.symbol}
                                />
                                <span>{s.deployment_meta.strategy.symbol}</span>
                              </>
                            ) : (
                              <>
                                <img
                                  src={
                                    darkTheme
                                      ? "/images/logos/Symbol_Dark.png"
                                      : "/images/logos/Symbol_Light-30.png"
                                  }
                                  style={{
                                    maxHeight: "30px",
                                    maxWidth: "30px",
                                  }}
                                  alt={s.deployment_meta.strategy.symbol}
                                />
                                <span>{s.deployment_meta.strategy.symbol}</span>
                              </>
                            )}
                          </div>
                        )}
                      </TableCell>
                      <TableCell>
                        {s.deployment_meta.strategy.timeframe}
                      </TableCell>
                      <TableCell className="whitespace-nowrap">
                        {formatEpochDate(s.epoch_created_at, "DD-MMM-YY")}
                      </TableCell>
                      <TableCell className="whitespace-nowrap">
                        {formatEpochDate(s.epoch_expired_at, "DD-MMM-YY")}
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="secondary"
                          onClick={() => {
                            router.push(
                              `/forward-test-performance/${
                                s?.deployment_meta?.id
                              }/${s?.deployment_meta?.strategy?.id}?locale=${
                                router.query.locale || "en"
                              }`
                            );
                          }}
                        >
                          {t("View Performance")}
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          )}
          {viewType == "virtual" ? (
            <Pagination
              totalCount={expiredVirtualStrategiesCount}
              currentPage={expiredVirtualStrategiesCurrent}
              changePage={expiredVirtualOnPageChange}
              limit={expiredStrategiesLimit}
            />
          ) : (
            <Pagination
              totalCount={expiredLiveStrategiesCount}
              currentPage={expiredLiveStrategiesCurrent}
              changePage={changeExpiredLiveStrategiesPage}
              limit={expiredStrategiesLimit}
            />
          )}
          {expiredStrategies.length == 0 ? (
            <div className="p-5 text-center">{t("noExpiry")}</div>
          ) : (
            ""
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
export default Section3;
